import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['tab', 'panel']

  connect() {
    // Get active tab from data attribute (set from cookie) or default to first tab
    const activeTab = this.element.dataset.tabsActiveTab
    if (activeTab) {
      const tabName = this.mapCookieValueToTab(activeTab)
      this.switchToTab(tabName)
    }
  }

  switch(event) {
    event.preventDefault()
    const tabName = event.currentTarget.dataset.tabName
    this.switchToTab(tabName)
  }

  mapCookieValueToTab(cookieValue) {
    const mapping = {
      profile: 'profile',
      'profile-signature': 'signature',
      'profile-initials': 'initials',
      'profile-password': 'password',
      'profile-transfer-document': 'transfer-document',
      'profile-two-factor-authentication': 'two-factor-authentication'
    }
    return mapping[cookieValue] || 'profile'
  }

  switchToTab(tabName) {
    // Remove active classes from all tabs
    this.tabTargets.forEach(tab => {
      tab.classList.remove('tab-bordered', 'border-b', 'border-cs-main-400', 'font-bold', 'text-cs-gray-lv-5')
    })

    // Hide all panels
    this.panelTargets.forEach(panel => {
      panel.classList.add('hidden')
    })

    // Add active class to selected tab - find the tab that contains the button with matching data-tab-name
    const activeTab = this.tabTargets.find(tab => {
      const button = tab.querySelector(`[data-tab-name="${tabName}"]`)
      return button !== null
    })
    if (activeTab) {
      activeTab.classList.add('tab-bordered', 'border-b', 'border-cs-main-400', 'font-bold', 'text-cs-gray-lv-5')
    }

    // Show selected panel
    const activePanel = this.panelTargets.find(panel => panel.dataset.panelName === tabName)
    if (activePanel) {
      activePanel.classList.remove('hidden')
    }
  }
}
